var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import getTheme from "../Theme";
import { Avatar, Button, Card, CardActions, CardContent, Checkbox, Divider, FormControl, FormControlLabel, FormGroup, LinearProgress, Radio, RadioGroup, Stack, TextField, Typography, } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useFileUploader } from "../hooks/useFileUploader";
import { AddAPhoto, 
//  PersonAdd,
//  Place,
Edit, IosShare, Close, } from "@mui/icons-material";
import { v4 as uuidv4 } from "uuid";
import { ContentCard } from "./ContentCard";
import { saveChannelData } from "../util/DataUtils";
import { useCacheBusterStore } from "../util/UrlUtils";
import { useLogger } from "../logger";
const cameraImg = "./img/camera_512.jpg";
export const NewChannelCard = (props) => {
    const canvasRef = useRef(null);
    // Generate channel ID once and reuse it for temp uploads and final channel
    const [channelId] = useState(uuidv4());
    const [addChannelTitle, setAddChannelTitle] = useState("");
    const [addChannelHelperTitle, setAddChannelHelperTitle] = useState(undefined);
    const [addChannelSubtitle, setAddChannelSubtitle] = useState("");
    const [addChannelHelperSubtitle, setAddChannelHelperSubtitle] = useState(undefined);
    const [addChannelText, setAddChannelText] = useState("");
    const [addChannelHelperText, setAddChannelHelperText] = useState(undefined);
    const [permissionsAdultContent, setPermissionsAdultContent] = useState(false);
    const [permissionsAllowsComments, setPermissionsAllowsComments] = useState(true);
    const [permissionsAllowsPosts, setPermissionsAllowsPosts] = useState(true);
    const [addChannelPrompt, setAddChannelPrompt] = useState("");
    const [addChannelHelperPrompt, setAddChannelHelperPrompt] = useState(undefined);
    const [addChannelImageUrl, setAddChannelImageUrl] = useState(cameraImg);
    const [addChannelSaving, setAddChannelSaving] = useState(false);
    const [addChannelSavedOk, setAddChannelSavedOk] = useState(false);
    const [addChannelSaveError, setAddChannelSaveError] = useState(undefined);
    const hiddenFileInputAddChannel = useRef(null);
    const [addChannelImageDataUrl, setAddChannelImageDataUrl] = useState("");
    const [access, setAccess] = useState("public");
    const [tempFile, setTempFile] = useState(null);
    const [tempImageDataUrl, setTempImageDataUrl] = useState("");
    const [uploadingImage, setUploadingImage] = useState(false);
    const [imageUploaded, setImageUploaded] = useState(false);
    const [tempImagePath, setTempImagePath] = useState("");
    const [pollingForProcessedImage, setPollingForProcessedImage] = useState(false);
    const [imagePollingProgress, setImagePollingProgress] = useState(0);
    const [imagePollingMessage, setImagePollingMessage] = useState("");
    const cacheBusterStore = useCacheBusterStore((state) => state);
    const logger = useLogger();
    // File uploader hook
    const fileUploader = useFileUploader({
        maxImageSize: 50 * 1024 * 1024,
        acceptedFileTypes: ["image/jpeg", "image/png"],
        onUploadError: (error) => {
            logger.error("NewChannelCard: Upload error: " + error.message);
            setAddChannelSaveError(error.message);
            setUploadingImage(false);
        },
    });
    const validateAddChannelTitle = (title) => {
        setAddChannelSaveError(undefined);
        setAddChannelSaving(false);
        if (!title) {
            setAddChannelHelperTitle(undefined);
            return;
        }
        if (title.includes("<")) {
            setAddChannelHelperTitle("Title cannot contain '<' character.");
        }
        else if (title.includes("@")) {
            setAddChannelHelperTitle("Title cannot contain '@' character.");
        }
        else if (title.includes("\n")) {
            setAddChannelHelperTitle("Title cannot contain newline character.");
        }
        else {
            setAddChannelHelperTitle(undefined);
        }
    };
    const validateAddChannelSubtitle = (title) => {
        setAddChannelSaveError(undefined);
        setAddChannelSaving(false);
        if (!title) {
            setAddChannelHelperSubtitle(undefined);
            return;
        }
        if (title.includes("<")) {
            setAddChannelHelperSubtitle("Subtitle cannot contain '<' character.");
        }
        else if (title.includes("\n")) {
            setAddChannelHelperSubtitle("Subtitle cannot contain newline character.");
        }
        else {
            setAddChannelHelperSubtitle(undefined);
        }
    };
    const validateAddChannelText = (text) => {
        setAddChannelSaveError(undefined);
        setAddChannelSaving(false);
        if (!text) {
            setAddChannelHelperText(undefined);
            return;
        }
        if (text.includes("<")) {
            setAddChannelHelperText("Text cannot contain '<' character.");
        }
        else {
            setAddChannelHelperText(undefined);
        }
    };
    const validateAddChannelPrompt = (prompt) => {
        setAddChannelSaveError(undefined);
        setAddChannelSaving(false);
        if (!prompt) {
            setAddChannelHelperPrompt(undefined);
            return;
        }
        if (prompt.includes("<")) {
            setAddChannelHelperPrompt("Member question cannot contain '<' character.");
        }
        else if (prompt.includes("\n")) {
            setAddChannelHelperPrompt("Member question cannot contain newline character.");
        }
        else {
            setAddChannelHelperPrompt(undefined);
        }
    };
    const pollForProcessedChannelImage = () => {
        // Poll for the final 1024px processed image that displays on channel cards
        const processedImageUrl = `https://content.mediashare.link/u/${props.auth.userId}/${channelId}/channelImage_1024.jpg`;
        logger.log(`NewChannelCard: Polling for processed channel image: ${processedImageUrl}`);
        setPollingForProcessedImage(true);
        setImagePollingProgress(0);
        setImagePollingMessage("Processing channel image...");
        const MAX_ATTEMPTS = 24; // 60 seconds total (24 * 2.5s = 60s)
        let attempts = 0;
        const pollInterval = setInterval(() => {
            attempts++;
            const progressPercentage = Math.min((attempts / MAX_ATTEMPTS) * 100, 100);
            logger.log(`NewChannelCard: Image polling attempt ${attempts}/${MAX_ATTEMPTS}`);
            // Update polling progress
            setImagePollingProgress(progressPercentage);
            if (attempts <= 8) {
                setImagePollingMessage("Processing channel image...");
            }
            else if (attempts <= 16) {
                setImagePollingMessage("Still processing image...");
            }
            else {
                setImagePollingMessage("Final image processing...");
            }
            // Try to fetch the processed 1024px image
            fetch(processedImageUrl, { method: "HEAD" })
                .then((response) => {
                if (response.ok) {
                    logger.log("NewChannelCard: Processed channel image found! Processing complete.");
                    clearInterval(pollInterval);
                    setPollingForProcessedImage(false);
                    setImagePollingProgress(0);
                    setImagePollingMessage("");
                    // Show success
                    const handleOk = () => {
                        console.log("doPublish: handleOk");
                        setAddChannelSaving(false);
                        setAddChannelSaveError(undefined);
                        setTimeout(() => {
                            setAddChannelSavedOk(true);
                        }, 300);
                    };
                    handleOk();
                }
                else if (attempts >= MAX_ATTEMPTS) {
                    logger.log("NewChannelCard: Max polling attempts reached. Proceeding anyway.");
                    clearInterval(pollInterval);
                    setPollingForProcessedImage(false);
                    setImagePollingProgress(0);
                    setImagePollingMessage("");
                    // Show success even if we didn't find the processed image - don't block user
                    const handleOk = () => {
                        console.log("doPublish: handleOk");
                        setAddChannelSaving(false);
                        setAddChannelSaveError(undefined);
                        setTimeout(() => {
                            setAddChannelSavedOk(true);
                        }, 300);
                    };
                    handleOk();
                }
                // Otherwise continue polling
            })
                .catch((error) => {
                logger.log(`NewChannelCard: Polling attempt ${attempts} failed: ${error.message}`);
                if (attempts >= MAX_ATTEMPTS) {
                    logger.log("NewChannelCard: Max polling attempts reached after errors. Proceeding anyway.");
                    clearInterval(pollInterval);
                    setPollingForProcessedImage(false);
                    setImagePollingProgress(0);
                    setImagePollingMessage("");
                    // Show success even on errors - don't block user
                    const handleOk = () => {
                        console.log("doPublish: handleOk");
                        setAddChannelSaving(false);
                        setAddChannelSaveError(undefined);
                        setTimeout(() => {
                            setAddChannelSavedOk(true);
                        }, 300);
                    };
                    handleOk();
                }
                // Otherwise continue polling
            });
        }, 2500); // 2.5 second intervals
    };
    const doPublish = () => {
        console.log("doPublish");
        const handleError = (errorMessage) => {
            console.log("doPublish: handleError " + errorMessage);
            setTimeout(() => {
                setAddChannelSaveError(errorMessage);
                setAddChannelSavedOk(false);
                setAddChannelSaving(false);
            }, 300);
        };
        const handleOk = () => {
            console.log("doPublish: handleOk");
            setAddChannelSaving(false);
            setAddChannelSaveError(undefined);
            setTimeout(() => {
                setAddChannelSavedOk(true);
            }, 300);
        };
        setAddChannelSaveError(undefined);
        setAddChannelSavedOk(false);
        setAddChannelSaving(true);
        if (!props.auth || !props.auth.isSignedIn() || !props.auth.userId) {
            console.error("User not signed in.");
            handleError("User is not signed in.");
            return;
        }
        const inputData = {
            title: addChannelTitle,
            subtitle: addChannelSubtitle,
            description: addChannelText,
            channelOwnerId: props.auth.userId,
            channelId: channelId,
            membershipPrompt: addChannelPrompt,
            private: access == "private" ? true : false,
            tempImagePath: tempImagePath || undefined,
            permissions: {
                permissionsAdultContent,
                permissionsAllowsComments,
                permissionsAllowsPosts,
                permissionsAllowsDiscovery: true,
            },
        };
        logger.log("NewChannelCard: Saving Channel: " + JSON.stringify(inputData));
        logger.log(`NewChannelCard: Temp image uploaded: ${imageUploaded}, temp file exists: ${!!tempFile}`);
        // Clean up temp file blob URL when saving
        const cleanupTempFile = () => {
            if (tempImageDataUrl && tempImageDataUrl.startsWith("blob:")) {
                URL.revokeObjectURL(tempImageDataUrl);
                setTempImageDataUrl("");
            }
        };
        // Save channel data - backend will detect and process temp images automatically
        saveChannelData(inputData, {
            okCallback: (clientDetailCode) => {
                logger.log("NewChannelCard: okCallback: " + clientDetailCode);
                cleanupTempFile();
                // If temp image was uploaded, wait 6 seconds then start polling for processed image
                if (tempImagePath) {
                    logger.log("NewChannelCard: Waiting 6 seconds then polling for processed channel image...");
                    setTimeout(() => {
                        logger.log("NewChannelCard: Starting to poll for processed channel image (channelImage_1024.jpg)");
                        // Start polling to verify processed channel image exists
                        pollForProcessedChannelImage();
                    }, 6000);
                }
                else {
                    // For non-image updates, proceed immediately
                    handleOk();
                }
                return;
            },
            errorCallback: (clientDetailCode, errorMessage) => {
                handleError(errorMessage + " (" + clientDetailCode + ")");
                return;
            },
            authCallback: {
                isSignedIn: () => props.auth.isSignedIn(),
                bearer: () => props.auth.bearer,
                sequence: () => props.auth.sequence,
                setBearerAndSequence: (bearer, sequence) => {
                    props.auth.setBearerAndSequence(bearer, sequence, logger);
                },
                getAuth: () => {
                    return props.auth;
                },
            },
        }, cacheBusterStore, logger);
    };
    useEffect(() => {
        console.log("useEffect: addChannelPrompt = " + addChannelPrompt);
        validateAddChannelPrompt(addChannelPrompt);
        return () => { };
    }, [addChannelPrompt]);
    useEffect(() => {
        console.log("useEffect: addChannelText = " + addChannelText);
        validateAddChannelText(addChannelText);
        return () => { };
    }, [addChannelText]);
    useEffect(() => {
        console.log("useEffect: addChannelTitle = " + addChannelTitle);
        validateAddChannelTitle(addChannelTitle);
        return () => { };
    }, [addChannelTitle]);
    useEffect(() => {
        console.log("useEffect: addChannelSubtitle = " + addChannelSubtitle);
        validateAddChannelSubtitle(addChannelSubtitle);
        return () => { };
    }, [addChannelSubtitle]);
    useEffect(() => {
        console.log("useEffect: mount - addChannelSavedOk = " + addChannelSavedOk);
        if (addChannelSavedOk) {
            const newChannelName = addChannelTitle;
            setTimeout(() => {
                setAddChannelSavedOk(false);
                setAddChannelTitle("");
                setAddChannelSubtitle("");
                setAddChannelText("");
                setAddChannelImageUrl(undefined);
                if (props.created) {
                    props.created(newChannelName);
                }
            }, 4000);
        }
        return () => {
            console.log("useEffect: unmount - addChannelSavedOk");
        };
    }, [addChannelSavedOk]);
    useEffect(() => {
        console.log("useEffect: mount - addChannelSaveError = " + addChannelSaveError);
        if (addChannelSaveError) {
            setTimeout(() => {
                setAddChannelSaveError(undefined);
            }, 5000);
        }
        return () => {
            console.log("useEffect: unmount - addChannelSaveError");
        };
    }, [addChannelSaveError]);
    useEffect(() => {
        console.log("useEffect: mount - addChannelImageDataUrl = " + !!addChannelImageDataUrl);
        return () => {
            console.log("useEffect: unmount - addChannelImageDataUrl");
        };
    }, [addChannelImageDataUrl]);
    const addChannelImageFilenameChanged = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        logger.log("NewChannelCard: addChannelImageFilenameChanged");
        if (!((_a = hiddenFileInputAddChannel.current) === null || _a === void 0 ? void 0 : _a.files) ||
            hiddenFileInputAddChannel.current.files.length === 0) {
            return;
        }
        const file = hiddenFileInputAddChannel.current.files[0];
        logger.log(`NewChannelCard: Selected file: ${file.name}, type: ${file.type}, size: ${file.size}`);
        // Clear any existing errors
        setAddChannelSaveError(undefined);
        // Validate file type
        if (file.type !== "image/jpeg" && file.type !== "image/png") {
            setAddChannelSaveError(`Unsupported file type: ${file.type}. Please select a JPEG or PNG image.`);
            return;
        }
        // Validate file size (50MB max)
        if (file.size > 50 * 1024 * 1024) {
            setAddChannelSaveError("File size too large. Please select an image smaller than 50MB.");
            return;
        }
        // Set temp file and create blob URL for immediate preview
        setTempFile(file);
        const blobUrl = URL.createObjectURL(file);
        setTempImageDataUrl(blobUrl);
        setAddChannelImageDataUrl(blobUrl);
        setAddChannelImageUrl(blobUrl);
        logger.log(`NewChannelCard: Preview URL created: ${blobUrl}`);
        // Start upload to temp location immediately
        setUploadingImage(true);
        const timestamp = new Date().getTime();
        try {
            // Determine file extension based on original file type
            let fileType = "jpg";
            if (file.type === "image/png")
                fileType = "png";
            // Upload to temp location with original file type
            const tempPartition = `tmp/${props.auth.userId}/${channelId}`;
            const contentId = `channelImage_${timestamp}`;
            logger.log(`NewChannelCard: Uploading to temp location: ${tempPartition}/${contentId}.${fileType}`);
            yield fileUploader.uploadFile({
                file,
                contentId,
                partition: tempPartition,
                auth: props.auth,
                cacheBusterStore,
            });
            // Store the temp file path with original file type for backend
            const tempFilePath = `${tempPartition}/${contentId}.${fileType}`;
            setTempImagePath(tempFilePath);
            logger.log("NewChannelCard: Temp upload successful");
            logger.log(`NewChannelCard: Temp image path: ${tempFilePath}`);
            setUploadingImage(false);
            setImageUploaded(true);
        }
        catch (error) {
            logger.error(`NewChannelCard: Temp upload failed: ${error}`);
            setAddChannelSaveError(`Upload failed: ${error.message}`);
            setUploadingImage(false);
            // Clean up blob URL on error
            if (blobUrl) {
                URL.revokeObjectURL(blobUrl);
            }
            setTempFile(null);
            setTempImageDataUrl("");
            setAddChannelImageDataUrl("");
            setAddChannelImageUrl(cameraImg);
        }
    });
    const addChannelMediaClicker = () => {
        console.log("addChannelMediaClicker: add Channel - upload - click");
        if (hiddenFileInputAddChannel.current) {
            console.log("addChannelMediaClicker: add Channel - upload - click: Click: hiddenFileInput");
            hiddenFileInputAddChannel.current.click();
        }
        else {
            console.error("addChannelMediaClicker: missing hidden file input reference");
        }
    };
    const addChannelCardContent = (_jsxs(Stack, Object.assign({ style: { padding: "10px" } }, { children: [!addChannelSavedOk && (_jsx(TextField, { "aria-label": "Title Field", fullWidth: true, id: "outlined-multiline-static-title", label: "Title", color: "black", size: "small", onChange: (event) => {
                    const value = event.target.value;
                    console.log("add Channel title onChange - " + value);
                    setAddChannelTitle(value);
                }, error: !!addChannelHelperTitle, helperText: addChannelHelperTitle, disabled: addChannelSaving, value: addChannelTitle, sx: { marginBottom: "8px" } }, "cards.addChannel.cardcontent.textfield.title")), !addChannelSavedOk && (_jsx(TextField, { "aria-label": "Subtitle Field", fullWidth: true, id: "outlined-multiline-static-subtitle", label: "Subtitle", color: "black", size: "small", onChange: (event) => {
                    const value = event.target.value;
                    console.log("add Channel subtitle onChange - " + value);
                    setAddChannelSubtitle(value);
                }, error: !!addChannelHelperSubtitle, helperText: addChannelHelperSubtitle, disabled: addChannelSaving, value: addChannelSubtitle, sx: { marginBottom: "8px" } }, "cards.addChannel.cardcontent.textfield.subtitle")), !addChannelSavedOk && (_jsx(TextField, { "aria-label": "Description Field", fullWidth: true, id: "outlined-multiline-static", label: "Describe your channel here...", multiline: true, rows: 2, color: "black", onChange: (event) => {
                    const value = event.target.value;
                    console.log("add channel text onChange - " + value);
                    setAddChannelText(value);
                }, error: !!addChannelHelperText, helperText: addChannelHelperText, disabled: addChannelSaving, value: addChannelText, sx: { marginBottom: "3px" } }, "cards.addChannel.cardcontent.textfield")), !addChannelSaving && !addChannelSavedOk && (_jsx(Button, Object.assign({ variant: addChannelImageUrl != cameraImg ? "outlined" : "contained", endIcon: _jsx(AddAPhoto, {}), onClick: () => {
                    addChannelMediaClicker();
                }, disabled: uploadingImage, sx: { marginBottom: "10px", marginTop: "5px" } }, { children: uploadingImage ? "UPLOADING..." : "ADD PHOTO" }), "cards.addChannel.button.photo")), uploadingImage && (_jsxs(Stack, Object.assign({ spacing: 1, sx: { marginBottom: "10px" } }, { children: [_jsx(Typography, Object.assign({ variant: "body2", color: "primary" }, { children: "Uploading image..." })), _jsx(LinearProgress, {})] }))), !addChannelSavedOk && !addChannelSaving && _jsx(Divider, {}), !addChannelSaving && !addChannelSavedOk && (_jsxs(FormControl, { children: [_jsx(Typography, Object.assign({ variant: "body1", color: "primary", gutterBottom: true }, { children: "ACCESS" }), "cards.settings.cardcontent.type.access"), _jsxs(RadioGroup, Object.assign({ "aria-labelledby": "radio-buttons-group-channel-access-label", name: "radio-buttons-group-channel-access-name", onChange: (event) => {
                            const value = event.target.value;
                            console.log("setAccess: " + value);
                            setAccess(value);
                        }, value: access }, { children: [_jsx(FormControlLabel, { value: "public", control: _jsx(Radio, {}), label: "Public - Anyone can view channel content." }), _jsx(FormControlLabel, { value: "private", control: _jsx(Radio, {}), label: "Private - Channel viewers must be approved by channel owner." })] }))] })), !addChannelSavedOk && !addChannelSaving && access == "private" && (_jsx(TextField, { fullWidth: true, id: "outlined-multiline-static-memberprompt", label: "What question do you want to ask potential members? (optional)", multiline: true, rows: 2, color: "black", onChange: (event) => {
                    const value = event.target.value;
                    console.log("add channel prompt onChange - " + value);
                    setAddChannelPrompt(value);
                }, error: !!addChannelHelperPrompt, helperText: addChannelHelperPrompt, disabled: addChannelSaving, value: addChannelPrompt, sx: { marginBottom: "3px" } }, "cards.addChannel.cardcontent.memberprompt")), !addChannelSavedOk && !addChannelSaving && _jsx(Divider, {}), !addChannelSavedOk && !addChannelSaving && (_jsx(Typography, Object.assign({ variant: "body1", color: "primary", gutterBottom: true }, { children: "VIEWER PERMISSIONS" }), "cards.settings.cardcontent.type.permissions")), !addChannelSavedOk && !addChannelSaving && (_jsx(Stack, Object.assign({ direction: "column", sx: {
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    paddingLeft: "15px",
                    paddingRight: "15px",
                } }, { children: _jsx(FormControl, Object.assign({ sx: { display: "flex", justifyContent: "center" } }, { children: _jsxs(FormGroup, Object.assign({ sx: { display: "flex", justifyContent: "center" } }, { children: [_jsx(FormControlLabel, { label: "Posts contain adult content.", control: _jsx(Checkbox, { checked: permissionsAdultContent, onChange: (event) => {
                                        const checked = event.target.checked;
                                        console.log("permissionsAdultContent - checked/unchecked: " +
                                            checked);
                                        setPermissionsAdultContent(checked);
                                    } }) }), _jsx(FormControlLabel, { label: "Viewers can post to the channel.", control: _jsx(Checkbox, { checked: permissionsAllowsPosts, onChange: (event) => {
                                        console.log("permissionsAllowsPosts - checked/unchecked: " +
                                            event.target.checked);
                                        setPermissionsAllowsPosts(event.target.checked);
                                    } }) }), _jsx(FormControlLabel, { label: "Viewers can comment on posts.", control: _jsx(Checkbox, { checked: permissionsAllowsComments, onChange: (event) => {
                                        console.log("permissionsAllowsComments - checked/unchecked: " +
                                            event.target.checked);
                                        setPermissionsAllowsComments(event.target.checked);
                                    } }) })] })) })) }))), _jsxs(Stack, Object.assign({ direction: "row", width: "100%", sx: { display: "flex", justifyContent: "center", marginTop: "5px" }, spacing: 1 }, { children: [_jsx("input", { type: "file", accept: "image/jpeg,image/png", ref: hiddenFileInputAddChannel, style: { display: "none" }, onChange: addChannelImageFilenameChanged }, "add-Channel-hidden-file-input"), _jsx("canvas", { ref: canvasRef, style: { display: "none" } }, "canvas.newChannelcard"), (addChannelSaving ||
                        (addChannelSavedOk && pollingForProcessedImage)) && (_jsx(Card, Object.assign({ elevation: 0, sx: {
                            backgroundColor: addChannelSaving ? "#F0F8FF" : "#E8F5E8",
                            padding: "4",
                            marginTop: "0.5em",
                        }, color: "text.primary" }, { children: _jsxs(CardContent, { children: [_jsx(Typography, Object.assign({ variant: "h6", component: "div", color: "primary", gutterBottom: true }, { children: addChannelSaving ? "SAVING..." : "PROCESSING..." })), _jsx(Typography, Object.assign({ variant: "body2", color: "black", sx: { marginBottom: "15px" } }, { children: addChannelSaving
                                        ? "Saving your channel settings..."
                                        : imagePollingMessage })), _jsx(LinearProgress, { variant: addChannelSaving ? "indeterminate" : "determinate", value: addChannelSaving ? undefined : imagePollingProgress, sx: { marginBottom: "10px" } }), !addChannelSaving && (_jsxs(Typography, Object.assign({ variant: "body2", color: "primary", sx: { textAlign: "center" } }, { children: [Math.round(imagePollingProgress), "% complete"] })))] }, "add-Channel-combined-progress-content") }), "add-Channel-combined-progress-card"))] }), "add-Channel-stack-2-" + addChannelSavedOk), addChannelSaveError && (_jsxs(Card, Object.assign({ elevation: 0, sx: { backgroundColor: "#FFEEEE", padding: "4", marginTop: "0.5em" }, color: "text.error" }, { children: [_jsxs(CardContent, { children: [_jsx(Typography, Object.assign({ variant: "h6", component: "div", color: "error", gutterBottom: true }, { children: "SAVE FAILED" })), _jsx(Typography, Object.assign({ variant: "body2" }, { children: addChannelSaveError }))] }, "add-Channel-error-card-content"), _jsx(CardActions, Object.assign({ sx: { display: "flex", justifyContent: "center" } }, { children: _jsx(Button, Object.assign({ onClick: () => {
                                setAddChannelSaveError(undefined);
                            } }, { children: "DISMISS" })) }))] }), "add-Channel-error-card")), addChannelSavedOk && !pollingForProcessedImage && (_jsx(Card, Object.assign({ elevation: 0, sx: { backgroundColor: "#EEFFEE", padding: "4", marginTop: "0.5em" }, color: "text.error" }, { children: _jsxs(CardContent, { children: [_jsx(Typography, Object.assign({ variant: "h6", component: "div", color: "EEFFEE", gutterBottom: true }, { children: "CREATED" })), _jsx(Typography, Object.assign({ variant: "body2", color: "black" }, { children: "Your channel has been created." }))] }, "add-Channel-saved-ok-card-content") }), "add-Channel-saved-ok-card" + addChannelSavedOk))] }), "add-Channel-stack-card-" + addChannelSavedOk + addChannelSaveError));
    const addChannelCardActions = (_jsxs(CardActions, Object.assign({ sx: { display: "flex", justifyContent: "center", padding: 0, margin: 0 } }, { children: [!addChannelSaving && (_jsx(Button, Object.assign({ "aria-label": "Create Channel", endIcon: _jsx(IosShare, {}), variant: "contained", onClick: () => {
                    doPublish();
                }, sx: { margin: "0.5em" }, disabled: !addChannelTitle ||
                    !!addChannelHelperTitle ||
                    !!addChannelHelperSubtitle ||
                    !!addChannelHelperText ||
                    (!addChannelText && !tempFile) ||
                    uploadingImage }, { children: "Create" }), "cards.addChannel.button.publish")), !addChannelSaving && (_jsx(Button, Object.assign({ endIcon: _jsx(Close, {}), variant: "outlined", onClick: () => {
                    props.dismiss();
                }, sx: { margin: "0.5em" } }, { children: "Cancel" }), "cards.addChannel.button.dismiss"))] }), "add-Channel-card-actions"));
    const addChannelCard = (_jsx(ContentCard, { keyStr: "content.card.addChannel." + addChannelSavedOk + addChannelImageDataUrl, title: "New Channel", backgroundColor: getTheme().palette.violet.contrastText, textColor: getTheme().palette.black.main, childComponent: addChannelCardContent, actions: !addChannelSavedOk && !addChannelSaving
            ? addChannelCardActions
            : undefined, mediaUrl: addChannelImageDataUrl ? addChannelImageDataUrl : cameraImg, maxWidth: 0.5, overlayIcon: _jsx(Avatar, Object.assign({ sx: {
                marginLeft: "auto",
                backgroundColor: getTheme().palette.violet.light,
            } }, { children: _jsx(Edit, {}) }), "settings.overlay.edit.button"), onMediaClick: () => {
            addChannelMediaClicker();
        } }, "content.card.addChannel." + addChannelSavedOk + addChannelImageDataUrl));
    return addChannelCard;
};
